// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/frontal-passage-indicators.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/frontal-passage-indicators/frontal-passage-indicators.js';

mount([g0]);
